import { PaymentData, qrImageUrl } from "../../../config/payments"
import { registrationEmailUtmParameters } from "../send/sendRegisterEmail"
import { thankYou } from "./subDefinitions/emailComponents"
import moment from "moment"
import "moment/locale/cs"
import { generateButtonPdfVoucherLink } from "./subDefinitions/generateButtonPdfVoucherLink"
import { generateEmailCallToActionButton, generateEmailParagraph, generateEmailText, spaceDivider } from "../generateEmailParagraph"
import { getOpenCoursesOffer } from "./subDefinitions/openCoursesOffer"

moment.locale("cs")

const emailDefinition1RegisterIntoOnlineCourseSubject = "Potvrzení registrace a informace o platbě, Vzdělání budoucnosti"

export const emailDefinition1RegisterIntoOnlineCourse = (
  courseTitle: string,
  when: string,
  courseDetailPageUrl: string,
  equipmentBuyFromOrganization: boolean,
  paymentData: PaymentData,
  courseListOffer: string,
  downloadPdfVoucherUrl?: string
): { body: string; subject: string } => ({
  body: `
  ${generateEmailParagraph("Dobrý den, ")}
  
  ${generateEmailParagraph(
    `s radostí Vám oznamujeme, že jste úspěšně zaregistrovaný(á) do online kurzu <strong>"${courseTitle}"</strong>, která byla provedena dne ${moment().format(
      "l"
    )}. Chystáme pro Vás zajímavý program, a těšíme se na Vaši účast.`
  )}
  
  ${generateEmailText(`<strong>Datum a čas konání kurzu:</strong>`)}
  ${generateEmailParagraph(when)}
  
  ${generateEmailText(`<strong>Forma:</strong>`)}
  ${generateEmailParagraph(`Online setkání skrze platformu Google Meet.`)}
  
  ${generateEmailText(`<strong>Platební informace:</strong>`)}
  ${generateEmailParagraph(`Prosím, uskutečněte platbu pomocí níže uvedených údajů. Jakmile bude Vaše platba potvrzena, obdržíte od nás oznámení e-mailem.`)}
  
  ${generateEmailParagraph(`
  Banka: Fio banka<br/>
  Číslo účtu: ${paymentData.account}/${paymentData.bank}<br/>
  Variabilní symbol: ${paymentData.variableNumber}<br/>
  ${
    paymentData.amount?.discount && paymentData.coupon
      ? `Částka: ${paymentData.amount?.discount > 0 ? `aplikována sleva kuponu ${paymentData.coupon.code}` : ""}`
      : "Částka: "
  }
  ${equipmentBuyFromOrganization ? `kurz + vybavení = ` : ""}${paymentData.amount.value} Kč<br/>
  Poznámka: ${paymentData.comment}<br/>
  Pro platbu ze zahraničí použijte SEPA platbu na číslo účtu ve formátu IBAN: ${paymentData.ibanAccount}<br/>
  <br/>Prosím, proveďte platbu do ${moment()
    .add(7, "days")
    .format("D. M. YYYY")} (7 kalendářních dnů), zároveň nejpozději v pátek, týden před začátkem kurzu.`)}
    
  ${generateEmailParagraph(`Můžete použít rychlejší způsob. Platbu pomocí QR kódu:`)}
  ${generateEmailCallToActionButton(
    "Vygenerovat QR kód",
    "Vygenerovat QR kód",
    qrImageUrl(paymentData.variableNumber, paymentData.amount.value, undefined, paymentData.comment)
  )}
  
  ${generateEmailText(`<strong>Další kroky po potvrzení platby:</strong>`)}
  ${generateEmailParagraph(
    `Jakmile obdržíme Vaši platbu a bude potvrzena, zašleme Vám připomínku - e-mail s dalšími důležitými informacemi, včetně detailních instrukcí, jak se připojit k online kurzu pomocí odkazu.`
  )}
  
  ${generateEmailText(`<strong>Přípravy:</strong>`)}
  ${generateEmailParagraph(`Pro tipy a návody, jak se připravit na konkrétní předmět kurzu, navštivte naši rubriku návody na blogu:`)}
  
  ${generateEmailCallToActionButton(
    "Získejte užitečné tipy",
    "Získejte užitečné tipy",
    `https://vzdelanibudoucnosti.cz/blog/stitek/navod${registrationEmailUtmParameters}`
  )}
  
  ${generateEmailParagraph(`Více informací o kurzu naleznete na našich webových stránkách.`)}
  
  ${generateEmailCallToActionButton("Více informací o kurzu", "Více informací o kurzu", `${courseDetailPageUrl}${registrationEmailUtmParameters}`)}
  
  ${generateButtonPdfVoucherLink(downloadPdfVoucherUrl)}
  
  ${spaceDivider}
  ${getOpenCoursesOffer(courseListOffer)}
  
  ${thankYou}
`,
  subject: emailDefinition1RegisterIntoOnlineCourseSubject
})
